<template>
    <b-card>
        <relation-info-table :relation="relation" />
        <div class="action">
            <a v-if="editRelation && $can('update-relations')"
                class="action_icon card-link pointer"
                :title="uLang('app.edit')"
                @click="editRelation(relation)"
            ><i class="fa fa-lg fa-edit"></i>
            </a>
            <a v-if="deleteRelation && $can('delete-relations')"
                class="action_icon card-link pointer"
                :title="uLang('app.delete')"
                @click="deleteRelation(relation)"
            ><i class="fa fa-lg fa-trash"></i>
            </a>
        </div>
    </b-card>
</template>
<script>
    import RelationInfoTable from '~/components/relations/basic-info-table'

    export default {
        props: {
            relation: {
                type: Object,
                default: null,
                required: true,
            },
            editRelation: {
                type: Function,
                required: false,
                default: null,
            },
            deleteRelation: {
                type: Function,
                required: false,
                default: null,
            },
        },

        components: {
            RelationInfoTable,
        },

        data() {
            return {}
        },
    }
</script>
<style lang="scss" scoped>
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }
</style>